/**
 * Reports API service - Handles HTTP requests for session report endpoints
 */

import { api } from '@/lib/api';

/** Response from GET /sessions/{sessionId}/report-url */
export interface ReportUrlResponse {
  /** Presigned S3 URL for the HTML report (expires after expiresIn seconds) */
  reportUrl: string;
  /** Seconds until the presigned URL expires (typically 3600) */
  expiresIn: number;
  /** Session ID the report belongs to */
  sessionId: string;
}

/**
 * Get a presigned S3 URL for viewing a session's HTML report
 * @param sessionId - Session identifier
 * @returns Promise resolving to ReportUrlResponse with presigned URL and expiry
 * @throws AuthError if not authenticated (401), session belongs to different user (403),
 *         session not found or report not generated (404), or server error (500)
 */
export async function getReportUrl(sessionId: string): Promise<ReportUrlResponse> {
  const response = await api.get<ReportUrlResponse>(`/sessions/${sessionId}/report-url`);
  return response.data;
}
